// extracted by mini-css-extract-plugin
export var orderSummary = "_nu-0";
export var showMoreLessButton = "_nu-1";